import { IFormMultiField, FieldDefinition, IDataModel } from 'types/form-types';

const isMultiInputField = <DataModel = IDataModel>(
  fieldDefinition: FieldDefinition<DataModel>
): fieldDefinition is IFormMultiField<DataModel> => {
  return fieldDefinition.hasOwnProperty('fields');
};

export { isMultiInputField };
